var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.formData)?_c('FormDesigner',{ref:"designer",attrs:{"formData":_vm.formData},on:{"save":_vm.onSave,"changed":_vm.onChanged,"history":_vm.onChangeFormData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }